import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Link } from "react-router-dom";
import { GripVertical } from "lucide-react";
import { FavoriteItem } from "@/hooks/use-favorites";

interface SortableFavoriteCardProps {
  fav: FavoriteItem;
  linkTo: string;
}

const SortableFavoriteCard = ({ fav, linkTo }: SortableFavoriteCardProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: fav.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 50 : "auto" as const,
  };

  return (
    <div ref={setNodeRef} style={style} className="flex items-stretch gap-0">
      <button
        {...attributes}
        {...listeners}
        className="flex items-center px-1.5 text-muted-foreground/50 hover:text-muted-foreground touch-none cursor-grab active:cursor-grabbing shrink-0"
        aria-label="Drag to reorder"
      >
        <GripVertical className="w-4 h-4" />
      </button>
      <Link
        to={linkTo}
        className="bg-card border border-border rounded-lg p-3 flex items-start gap-3 hover:border-primary/40 transition-colors flex-1 min-w-0"
      >
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-foreground">{fav.name}</p>
          <p className="font-mono text-primary text-sm font-bold mt-0.5">{fav.detail}</p>
        </div>
        <span className="text-[10px] text-muted-foreground shrink-0 mt-0.5">
          {fav.category.replace(/^[^\s]+\s/, "")}
        </span>
      </Link>
    </div>
  );
};

export default SortableFavoriteCard;
